import { Injectable } from '@angular/core';
import { HttpClient } from '../shared/wrappers/HttpClient';
import { Responsible } from '../models/Responsible.model';
import { User } from '../models/User.model';
import { UserSearchModel } from '../models/UserSearch.model';
import { Roles, RoleSearch } from "../models/Roles.model";
import { QueryBuilder } from "../shared/helpers/queryBuilder";

@Injectable()
export class UserService {

  constructor(private httpClient: HttpClient) { }

  endPoint: String = "/users";
  endPointUserAuth: String = "/user-auth";

  async getAllUsersAsResponsibles(): Promise<Responsible[]> {
    var usersJSON = await this.httpClient.get(this.endPoint);
    var responsibles = new Array<Responsible>();

    for (let u of usersJSON) {
      var responsibleModel = new Responsible();
      responsibleModel.loadUser(u);
      responsibles.push(responsibleModel);
    }

    return responsibles;
  }

  async getActiveUsers(): Promise<Responsible[]> {
    const users = await this.httpClient.get(this.endPoint);
    const responsiblesList = new Array<Responsible>();

    for (let user of users) {
        let responsible = new Responsible();
        if (user.active === true) {
            responsible.loadUser(user);
            responsiblesList.push(responsible);
        };
    };
    return responsiblesList
  }

  async getUserByUsername(username){
    try{
      return await this.httpClient.post(`${this.endPointUserAuth}`, { username });
    }catch(err){
      console.log(err);
    }
  }

    async getUsersByType(types, onlyActive = false): Promise<Responsible[]> {
        if(types.length > 0){

            const query = types.map(type => `type=${type}`);
            const querString = query.join('&');

            let usersJSON =  await this.httpClient.get(`${this.endPoint}/types?${querString}`);
            let users = new Array<Responsible>();

            if(onlyActive) {
                usersJSON = usersJSON.filter(user => user.active);
            }

            for (let u of usersJSON) {
                let user = new Responsible();
                user.loadUser(u);
                users.push(user);
            }

            return users;
        }
    }

    async getAllUsersWithSignerKey(): Promise<User[]>  {
        try {
            return await this.httpClient.get(`${this.endPoint}/keysigners`);
        } catch (err) {
            console.log(err)
        }
    }

    async getAllSignersDefault(excellenceCenter, type): Promise<User[]>  {
        try {
            return await this.httpClient.get(`${this.endPoint}/signers/default/?excellenceCenter=${excellenceCenter}&type=${type}`);
        } catch (err) {
            console.log(err)
        }
    }

    async getUserInfoWithKeySigner(keySigner: any) {
        try {
            return await this.httpClient.get(`${this.endPoint}/keysigners/${keySigner}`)
        } catch (err) {
            console.log(err)
            return false;
        }
    }

    async getAllUsers(): Promise<any> {
        return await this.httpClient.get(this.endPoint);
    }

    async searchUsers(userSearch: UserSearchModel): Promise<{data: User[], totalItems: number}> {
        let query = [];

        if (userSearch.name) query.push(`keywords=${userSearch.name}`)
        if (userSearch.username) query.push(`username=${userSearch.username}`)
        if (userSearch.type !== null && userSearch.type.length > 0) {
            query.push(`type=${userSearch.type.join(';')}`)
        }
        if(userSearch.active) query.push(`active=${userSearch.active}`)
        if(userSearch.limit) query.push(`limit=${userSearch.limit}`)
        if(userSearch.skip>=0) query.push(`skip=${userSearch.skip}`)

        const formatQuery = query.join('&');
        const response = await this.httpClient.get(`${this.endPoint}/search`, `?${formatQuery}`);

        let usersResponse: User[] = [];
        if (response.data && response.data.length > 0) {
            for(let user of response.data) {
                const userData = new User();
                userData.loadUserDataForGrid(user)
                usersResponse.push(userData);
            };
        };
        return {
            data: usersResponse,
            totalItems: response.total
        };
    }

    async update(user: User): Promise<User> {
        return await this.httpClient.update(`${this.endPoint}/auth`, user._id, user );
    }

    async create(user: User) {
        return await this.httpClient.post(this.endPoint, user);
    }

    async getById(id): Promise<User>{
        var userToEdit = new User();
        var response = await this.httpClient.get(`${this.endPoint}/auth/${id}`);
        userToEdit.loadUserDataForGrid(response);
        return userToEdit;
    }

    async getRoles(roleSearch: RoleSearch): Promise<Roles[]> {
        let querybuilded = QueryBuilder(roleSearch);
        return await this.httpClient.get(`${this.endPoint}/roles`, `?${querybuilded}`) as Roles[];
    }

}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts